import { useState, useEffect } from 'react';

interface PaymentStatusProps {
  remainingDraws: number;
  hasExpired: boolean;
}

export function PaymentStatus({ remainingDraws, hasExpired }: PaymentStatusProps) {
  if (hasExpired) {
    return (
      <div style={{ color: '#dc3545', fontWeight: 'bold' }}>
        Watermark currently enabled.
      </div>
    );
  }

  return (
    <div style={{ color: '#28a745', fontWeight: 'bold' }}>
      Watermark removed! {remainingDraws} draws remaining.
    </div>
  );
} 